var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentdue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35234",
    "data-name": "Group 35234",
    transform: "translate(-757.7 -295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9815",
    "data-name": "Rectangle 9815",
    width: 40,
    height: 40,
    transform: "translate(757.7 295)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35289",
    "data-name": "Group 35289",
    transform: "translate(760.7 299.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72290",
    "data-name": "Path 72290",
    d: "M55.7,4.4c0,1.878-4.186,3.4-9.35,3.4S37,6.278,37,4.4m18.7,0c0-1.878-4.186-3.4-9.35-3.4S37,2.522,37,4.4m18.7,0V6.95M37,4.4V24.8c0,1.878,4.186,3.4,9.35,3.4m0-13.6q-.43,0-.85-.014C40.734,14.43,37,12.974,37,11.2m9.35,10.2C41.186,21.4,37,19.878,37,18m34-2.55c0,1.878-4.186,3.4-9.35,3.4s-9.35-1.522-9.35-3.4m18.7,0c0-1.878-4.186-3.4-9.35-3.4s-9.35,1.522-9.35,3.4m18.7,0V28.2c0,1.878-4.186,3.4-9.35,3.4s-9.35-1.522-9.35-3.4V15.45M71,21.825c0,1.878-4.186,3.4-9.35,3.4s-9.35-1.522-9.35-3.4",
    transform: "translate(-37 -1)",
    fill: "none",
    stroke: "#ef6863",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentdue);
export default __webpack_public_path__ + "static/media/paymentdue.59ef58df9e601134c6837e6e2a766b87.svg";
export { ForwardRef as ReactComponent };